import * as React from 'react';
import { useDispatch } from 'react-redux';

import { toggleReportStatus } from '../../../actions/report';
import { EReportStatus } from '../../../constants/report';
import { useTrackPreviewReportBack } from '../tracking';

/**
 * При клике "Назад" в браузере, всегда сбрасываем
 * состояние страницы отчета на дефолтное
 */
export function useDidMount() {
  const dispatch = useDispatch();
  const trackPreviewReportBack = useTrackPreviewReportBack();

  React.useEffect(() => {
    window.addEventListener('popstate', () => {
      dispatch(toggleReportStatus(EReportStatus.Default));
      trackPreviewReportBack();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
